var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "media-container",
      attrs: { width: _vm.getWidth, height: _vm.getHeight },
      on: { click: _vm.mediaClicked }
    },
    [
      !_vm.mediaLoaded
        ? _c(
            "div",
            { staticClass: "spinner-container" },
            [
              _c("q-icon", {
                staticClass: "spinner",
                attrs: { allowSelfUpdate: false, spin: "", name: "spinner" }
              })
            ],
            1
          )
        : _c("img", {
            attrs: {
              width: _vm.getWidth,
              height: _vm.getHeight,
              src: _vm.dataUrl
            }
          })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39bc77f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39bc77f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/display/Media.vue
// module id = null
// module chunks = 